import Text from '@shared/components/content/text';
import Unit from '@shared/components/content/unit';
import { DateCell } from '@shared/components/data-table/cells/date-cell';
import { HeaderCell } from '@shared/components/data-table/cells/header-cell';
import { NumberCell } from '@shared/components/data-table/cells/number-cell';
import { ColumnDef } from '@tanstack/react-table';
import { PackagingTypesType } from '../packaging-list-page';

export function useGetPackagingColumns(): ColumnDef<PackagingTypesType>[] {
  return [
    {
      id: 'name',
      accessorKey: 'name',
      header: ({ column }) => (
        <HeaderCell column={column} name="Packaging type" />
      ),
      cell: ({ getValue }) => {
        const name = getValue<string>();
        return (
          <Text className="min-w-[150px] max-w-3xl truncate" includeHover>
            {name}
          </Text>
        );
      },
      enableHiding: false,
      enableColumnFilter: true,
      meta: {
        label: 'Search',
        variant: 'text',
        sorting: { ascLabel: 'A-Z', descLabel: 'Z-A' },
      },
    },
    {
      id: 'createdDate',
      accessorKey: 'createdDate',
      header: ({ column }) => (
        <HeaderCell column={column} name="Creation date" />
      ),
      cell: ({ getValue }) => {
        const date = getValue<string>();
        return (date && <DateCell date={date} />) ?? null;
      },
      enableSorting: true,
    },
    {
      id: 'numberOfTimesUsed',
      accessorKey: 'numberOfTimesUsed',
      header: ({ column }) => (
        <HeaderCell column={column} name="No. of times used" numberColumn />
      ),
      cell: ({ getValue }) => {
        const numberOfTimesUsed = getValue<number>();
        return <NumberCell number={numberOfTimesUsed} rounded />;
      },
    },
    {
      id: 'emissionsPerProductPackaged',
      accessorKey: 'emissionsPerProductPackaged',
      header: ({ column }) => (
        <HeaderCell
          column={column}
          name="Emissions per product packaged"
          unit={<Unit variant="gCO2e/item" />}
          numberColumn
        />
      ),
      cell: ({ getValue }) => {
        const emissionsPerProductPackaged = getValue<number | null>();

        if (!emissionsPerProductPackaged) return null;

        return <NumberCell number={emissionsPerProductPackaged! * 1000} />;
      },
    },
  ];
}
